export default __webpack_public_path__ + "static/media/195.457d258c.png";